// extracted by mini-css-extract-plugin
module.exports = {"Text":"css-modules_Text__d2WKe"};